import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { getAbbreviatedHash } from '../../utils/formatting';
import './HashDisplay.css';

const NARROW = '(max-width: 575.98px)';

/**
 * A hash or address in the project information table.
 *
 * These values are 42 to 66 unbroken characters. Printed in full they force the
 * table wider than a phone screen, which pushes the whole layout out of shape.
 *
 * On a narrow screen the value is abbreviated and becomes a tap target: tapping
 * opens a popover with the full value, selectable, and the link out to
 * Etherscan. Making the short form the trigger rather than the link avoids the
 * touch conflict where one tap would have to both navigate and reveal. On wider
 * screens it stays exactly as it was — a plain link showing the whole value.
 */
class HashDisplay extends Component {
  constructor(props) {
    super(props);
    this.mql = null;
    this.state = { narrow: false };
  }

  componentDidMount() {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    this.mql = window.matchMedia(NARROW);
    this.setState({ narrow: this.mql.matches });
    this.onChange = (e) => this.setState({ narrow: e.matches });
    // addEventListener is not available on MediaQueryList in older Safari.
    if (this.mql.addEventListener) this.mql.addEventListener('change', this.onChange);
    else if (this.mql.addListener) this.mql.addListener(this.onChange);
  }

  componentWillUnmount() {
    if (!this.mql) return;
    if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.onChange);
    else if (this.mql.removeListener) this.mql.removeListener(this.onChange);
  }

  render() {
    const { value, href, label } = this.props;
    if (!value) return <span>&mdash;</span>;

    if (!this.state.narrow) {
      return href
        ? <a className="hash-value" href={href} target="_new">{value}</a>
        : <span className="hash-value">{value}</span>;
    }

    const popover = (
      <Popover id={`hash-${value}`} className="hash-popover">
        {label && <Popover.Title as="h3">{label}</Popover.Title>}
        <Popover.Content>
          <div className="hash-full">{value}</div>
          {href && (
            <a href={href} target="_new" className="hash-etherscan">open in Etherscan</a>
          )}
        </Popover.Content>
      </Popover>
    );

    return (
      <OverlayTrigger trigger={['click', 'focus']} placement="top" overlay={popover} rootClose>
        <span className="hash-short" role="button" tabIndex={0}>
          {getAbbreviatedHash(value, 6, 6)}
        </span>
      </OverlayTrigger>
    );
  }
}

export default HashDisplay;
